export const formatNumber = (value) => {
  if (this.isEmpty(value)) return 0;
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};
export const formatNumber2 = (value, options) => {
  if (this.isEmpty(value) || isNaN(value) || value === 0) return '-';
  let dl = options['decimalLength'] || 0;
  let ts = options['thousandsSep'] || ',';
  let ty = options['type'] || '';
  let ut = options['unit'] || '';

  if (ty !== '') value = value * 100;
  value = parseFloat(value);
  let re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
  let num = value.toFixed(Math.max(0, ~~dl));
  return `${num.replace(new RegExp(re, 'g'), '$&' + ts)}${ut}`;
};
export const getPhoneFormat = (num, type = 1) => {
  let formatNum = '';
  try {
    if (num.length === 11) {
      if (type === 0) {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-****-$3');
      } else {
        formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
      }
    } else if (num.length === 8) {
      formatNum = num.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else {
      if (num.indexOf('02') === 0) {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-****-$3');
          } else {
            formatNum = num.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        }
      } else {
        if (num.length === 10) {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
          }
        } else {
          if (type === 0) {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-***-$3');
          } else {
            formatNum = num.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
          }
        }
      }
    }
  } catch (e) {
    formatNum = num;
  }
  return formatNum;
};
export const formatRpad = (target, value, n) => {
  return `${target}${Array(n - target.length + 1).join(value || '0')}`;
};
export const enumToValue = (enumList, key) => {
  const found = enumList.find((item) => item.value === key);
  return found ? found.label : key;
};
export const formatNumberToPhone = (value) => {
  if(!value) return '';
  return value.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
};
export const formatBizNum = (value) => {
  if (this.isEmpty(value)) return '';
  return value.replace(/([0-9]{3})([0-9]{2})([0-9]{5})/, '$1-$2-$3');
};
export const formatLpad = (target, value, n) => {
  if (this.isEmpty(target)) return '';
  target = target.toString();
  return `${Array(n - target.length + 1).join(value || '0')}${target}`;
};
export const formatStringBirth = (birth = '20010101') => {
  if (birth.length !== 8) return '';
  return `${birth.substr(0, 4)}.${birth.substr(4, 2)}.${birth.substr(6, 2)}`;
};
export const formatDateTime = (datetimeStr) => {
  if (!datetimeStr) return null;
  const date = new Date(datetimeStr);

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');

  return `${yyyy}.${mm}.${dd} ${hh}:${min}`;
};
export const formatDate = (datetimeStr) => {
  if (datetimeStr === null) return '-';
  const date = new Date(datetimeStr);

  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작
  const dd = String(date.getDate()).padStart(2, '0');

  return `${yyyy}.${mm}.${dd}`;
};
export const secondsToKorean = (seconds) => {
  const s = Number(seconds) || 0;
  if (s === 0) return '0초';
  const hrs = Math.floor(s / 3600);
  const mins = Math.floor((s % 3600) / 60);
  const secs = s % 60;

  const parts = [];
  if (hrs) parts.push(`${hrs}시간`);
  if (mins) parts.push(`${mins}분`);
  if (secs) parts.push(`${secs}초`);
  return parts.join(' ');
};
export const formatDateString = (dateStr, separator = '.') => {
  if (!dateStr) return '';
  const str = String(dateStr).replace(/\D/g, ''); // 숫자만 추출
  if (str.length !== 8) return str;
  const [y, m, d] = [str.slice(0, 4), str.slice(4, 6), str.slice(6, 8)];
  return [y, m, d].join(separator);
};